import fetch from "../../utils/fetch";

export function selectBussinessParkinglot(params) {
    
  return fetch({
    url: "/webApi/encrypt/parkinfo/selectBussinessParkinglot",
    method: "POST",
    isEncrypt: true,
    merId: "10002211252",
    data: params
  });
}

export function selectBussinessCoupon(query) {
  return fetch({
    url: "/webApi/encrypt/bussinessCoupon/selectBussinessCoupon",
    method: "POST",
    isEncrypt: true,
    merId: "10002211252",
    data: query
  });
}

// 轮询
export function sendCoupon(data) {
  return fetch({
    url: "/api/bussinessCoupon/wxSelectUnuseCouponInfoByTaskId",
    method: "get",
    params: data
  });
}
